// extracted by mini-css-extract-plugin
module.exports = {"prizeCard":"reward_prizeCard__geS55","image":"reward_image__Jie_K","text":"reward_text__A23uO","points":"reward_points__XyVXg"};